import { svgSprite } from '../../../../../../hybrid/wrappers';

const SingleMenuItemTitle = ({ isMobile, componentCss, menuItem, showSubMenu, idx, showSubMenuIdx }) => (
    <span style={{ display: 'flex', alignItems: 'center' }}>
        {!!isMobile && (
            <span className={componentCss?.menuItemImg}>
                {svgSprite(menuItem.icon, {
                    width: '24px',
                    height: '24px',
                    fill: showSubMenu && idx === showSubMenuIdx ? 'var(--blueColor)' : 'inherit'
                })}
            </span>
        )}
        <span>{menuItem.title}</span>
    </span>
);
export default SingleMenuItemTitle;
